<template>
  <div>
    <div class="form-personnal">
      <div class="ip">
        <vs-input v-model="user.last_name"
        :danger="errors.last_name ? true : false"
        :danger-text="errors.last_name ? errors.last_name[0] : ''"
        class="w-full" label="Nom"></vs-input>
      </div>
      <div class="ip">
        <vs-input v-model="user.first_name"
        :danger="errors.first_name ? true : false"
        :danger-text="errors.first_name ? errors.phone[0] : ''"
        class="w-full" label="Prénom"></vs-input>
      </div>
      <div class="ip">
        <vs-input v-model="user.email" class="w-full"
        :danger="errors.email ? true : false"
        :danger-text="errors.email ? errors.email[0] : ''"
        type="email" label="Email"></vs-input>
      </div>
      <div class="ip">
        <vs-input v-model="user.phone" class="w-full"
        :danger="errors.phone ? true : false"
        :danger-text="errors.phone ? errors.phone[0] : ''"
        type="number" label="Téléphone"></vs-input>
      </div>
    </div>
    <div class="bt-section">
      <vs-button @click="updateProfile">Sauvegarder</vs-button>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/helper/helper'
export default {
  data: () => ({
    user: {},
    errors: []
  }),
  mounted(){
    this.getUser()
  },
  methods:{
    getUser(){
      this.user = JSON.parse(localStorage.getItem('user_cnhu'))
    },
    updateProfile(){
      this.$vs.loading()
      this.$http.post('users/profile', {
        id: this.user.id,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        phone: this.user.phone,
      }).then(() => {
        this.errors = []
        this.$vs.loading.close()
        localStorage.setItem('user_cnhu', JSON.stringify(this.user))
        EventBus.$emit('updateProfile', this.user)
        this.$vs.notify({
          time: 5000,
          title: 'Succès!',
          text: "Opération effectuée avec succès",
          color: 'success',
          iconPack: 'feather',
          position: 'top-right',
          icon: 'icon-check-circle'
        })
      }).catch((error) => {
        this.$vs.loading.close()
        if (error.response.status === 422){
          this.errors= error.response.data.errors
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-personnal{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .ip{
    width: 24%;
  }
  .bt-section{
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
</style>
